import { AbstractFacade } from '@goparrot/common';
import deepmerge from 'deepmerge';
export class PlacePickerTemplateFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge({
            axiosConfig: {
                baseURL: process.env.GOPARROT_PLATFORM_SERVICE_WEBSTORE,
            },
        }, config), interceptors);
        this.basePrefix = '/api/v2/template-by-merchants';
    }
    async get(merchantId) {
        return (await this.client.get(`${this.basePrefix}/${merchantId}`)).data;
    }
}
//# sourceMappingURL=PlacePickerTemplateFacade.js.map